import React, { useState } from 'react';
import { BasicDialog, Colors, Text } from 'library';
import { Link } from 'library/ui';
import ErrorIcon from '@mui/icons-material/Error';

export default function ActionRequired() {
    const [open, setOpen] = useState(false);
    return (
        <div style={{ paddingTop: 12, paddingBottom: 6 }}>
            <Link
                onClick={() => setOpen(true)}
                color={Colors.mediumRed}
                icon={<ErrorIcon style={{ color: Colors.mediumRed, height: 18, width: 18 }} />}
            >
                Action Required
            </Link>

            <BasicDialog isOpen={open} onClose={() => setOpen(false)} closeButton>
                <Text bold variant="h2">
                    In order to confirm the workers compliance before they work, please ensure that you have completed
                    the following steps:
                </Text>
                <br />
                <Text>1. Log into Clearinghouse</Text>
                <Text>2. Click on the &apos;Background Screening&apos; tab</Text>
                <Text>3. Click &apos;Search&apos;</Text>

                <Text>
                    4. Type in the workers social security number (click the three dots next to their name on Tandem)
                </Text>
                <Text>5. Add the worker to your roster</Text>
                <br />
                <Text bold variant="body2">
                    Please note: If the worker has &apos;90 Day Lapse in Employment&apos; listed, please click
                    &apos;Initiate Resubmission&apos;. Then, you can add them to your roster.
                </Text>
                <br />
                <Text variant="caption" textStyle={{ fontStyle: 'italic' }}>
                    If you have any questions or trouble adding the worker to your roster, please email
                    support@join-tandem.com.
                </Text>
            </BasicDialog>
        </div>
    );
}
